'use strict';

var _themeA11y = require('@shopify/theme-a11y');

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();